// Product Page JavaScript

// Toggle ingredients content visibility with GSAP slide animation
function toggleIngredients(button) {
  // Wait for GSAP to be available
  if (typeof gsap === 'undefined') {
    console.warn('GSAP not loaded yet');
    return;
  }
  
  const content = button.nextElementSibling;
  const isOpen = !content.classList.contains('ingredients-closed');
  
  if (isOpen) {
    // Close: slide up
    // First, set height to current height (in case it was auto)
    const currentHeight = content.offsetHeight;
    gsap.set(content, { height: currentHeight });
    
    gsap.to(content, {
      height: 0,
      opacity: 0,
      duration: 0.4,
      ease: 'power2.inOut',
      onComplete: function() {
        content.classList.add('ingredients-closed');
        content.style.overflow = 'hidden';
      }
    });
    button.textContent = 'Ingredients +';
  } else {
    // Open: slide down
    content.classList.remove('ingredients-closed');
    content.style.display = 'block';
    content.style.overflow = 'hidden';
    
    // Get the natural height
    const height = content.scrollHeight;
    
    // Set initial state
    gsap.set(content, { height: 0, opacity: 0 });
    
    // Animate to full height
    gsap.to(content, {
      height: height,
      opacity: 1,
      duration: 0.4,
      ease: 'power2.inOut',
      onComplete: function() {
        content.style.height = 'auto';
        content.style.overflow = 'visible';
      }
    });
    button.textContent = 'Ingredients -';
  }
}

// Initialize ingredients content state on page load
function initIngredientsState() {
  // Wait for GSAP to be available
  if (typeof gsap === 'undefined') {
    setTimeout(initIngredientsState, 100);
    return;
  }
  
  const ingredientsContents = document.querySelectorAll('.ingredients-content');
  ingredientsContents.forEach(content => {
    if (content.classList.contains('ingredients-closed')) {
      gsap.set(content, { height: 0, opacity: 0, overflow: 'hidden' });
      content.style.display = 'block'; // Make it block so height can be animated
    }
  });
}

// Initialize Slick slider for ingredient images on mobile
function initIngredientSlider() {
  if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
    setTimeout(initIngredientSlider, 100);
    return;
  }

  const $slider = jQuery('.ingredients-slider');
  if ($slider.length === 0) return;

  function toggleSlider() {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile && !$slider.hasClass('slick-initialized')) {
      $slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: '60px'
      });
    } else if (!isMobile && $slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }
  }

  jQuery(document).ready(toggleSlider);

  let resizeTimeout;
  jQuery(window).on('resize', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(toggleSlider, 250);
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initIngredientSlider();
    initIngredientsState();
  });
} else {
  initIngredientSlider();
  initIngredientsState();
}

